<template>
    <div v-show="!loading">

        <v-sheet :class="counterSize === 'medium' ? 'text-center pt-5' : 'text-center pt-2'">
            <div style="display: inline-block;" class="title grey--text pa-2">{{hint}}</div>
            <trend-arrow v-if="trendAngle" :angle="trendAngle"></trend-arrow>
        </v-sheet>

        <div class="counterBase">
            <flip-number v-for="(number,index) in numbers"
                         :key="index"
                         :size="counterSize"
                         :value="number"></flip-number>
        </div>

    </div>
</template>

<script>

    import FlipNumber from './FlipNumber';
    import TrendArrow from './TrendArrow';

    export default {

        components: {
            FlipNumber,
            TrendArrow
        },

        props: {

            startValue: {
                type: Number | null,
                required: true
            },

            endValue: {
                type: Number | null,
                required: true
            },

            duration: {
                type: Number,
                required: true,
            },

            hint: {
                type: String,
                required: true,
            },

            loading: {
                type: Boolean,
                required: false,
                default: false
            },
            digits: {
                type: Number,
                required: false,
                default: null
            },
            trendAngle: {
                type: Number,
                required: false,
                default: null
            }
        },
        data() {
            return {
                currentCount: 0,
                interval: null,
                numbers: [],
                counterSize: 'large'
            }
        },

        computed: {
            intervalDuration() {
                if (this.endValue <= this.startValue) {
                    return 1;
                }
                return this.duration / (this.endValue - this.startValue);
            }
        },

        watch: {
            startValue(value) {
                this.initialize();
            },
        },

        methods: {
            startCounter() {
                if (this.intervalDuration) {

                    // Stop old interval if still running
                    if (this.interval) clearInterval(this.interval);

                    this.interval = setInterval(() => {
                        this.currentCount++;
                        this.parseDigits();

                    }, this.intervalDuration);
                }
            },
            parseDigits() {

                let digitString = '';

                if (this.currentCount) {
                    digitString = this.currentCount.toString();
                }

                this.numbers = [];

                const digits = this.digits ? this.digits : 1;

                if (digitString.length < digits) {

                    for (let i = 0; i < digits - digitString.length; i++) {
                        this.numbers.push(0);
                    }
                }

                for (let index = 0; index < digitString.length; index++) {
                    this.numbers.push(digitString[index]);
                }

                this.counterSize = this.numbers.length > 5 ? 'medium' : 'large';
            },

            initialize() {
                this.currentCount = this.startValue;
                if (this.endValue > this.startValue) {
                    this.parseDigits();
                    this.startCounter();
                } else {
                    this.parseDigits();
                }
            }
        },

        mounted() {
            this.initialize();
        },
    }
</script>

<style scoped>
    .counterBase {
        width: 100%;
        display: inline-block;
        text-align: center;
    }
</style>